import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Mail, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/5 pt-24 pb-10 px-6 md:px-10 mt-32"
    >
      <div className="max-w-[1500px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_sneaker-hub-242/artifacts/44serdge_Suzel%20gold.png"
              alt="Suzel Holding"
              className="h-24 md:h-28 w-auto mb-6"
              data-testid="footer-logo"
            />
            <p className="overline mb-4">Suzel Holding</p>
            <h3 className="font-display text-4xl md:text-5xl tracking-tight text-white leading-[1.1] mb-6">
              {t("footer.title1")}
              <br />
              <span className="italic text-[#C5A059]">{t("footer.title2")}</span>
            </h3>
            <p className="text-[#A1A1AA] max-w-md leading-relaxed">
              {t("footer.desc")}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">{t("footer.universes")}</p>
            <ul className="space-y-3 font-grotesk text-sm text-white/80">
              <li><Link to="/sneakers" data-testid="footer-link-sneakers" className="link-underline">{t("cat.sneakers.label")}</Link></li>
              <li><Link to="/perruques" data-testid="footer-link-perruques" className="link-underline">{t("cat.wigs.label")}</Link></li>
              <li><Link to="/haute-couture" data-testid="footer-link-couture" className="link-underline">{t("cat.couture.label")}</Link></li>
              <li><Link to="/epicerie" data-testid="footer-link-epicerie" className="link-underline">{t("cat.epicerie.label")}</Link></li>
              <li><Link to="/patisserie" data-testid="footer-link-patisserie" className="link-underline">{t("cat.patisserie.label")}</Link></li>
              <li><Link to="/printing" data-testid="footer-link-printing" className="link-underline">{t("cat.printing.label")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-5">{t("footer.contact")}</p>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/80">
                <MapPin size={16} className="text-[#C5A059] mt-0.5 shrink-0" />
                <span>Av. Walikale, Entrée Modé, {t("contact.addressLine2").replace("face à ", "").replace("across from ", "")} — Goma, {t("hero.location").includes("DRC") ? "DRC" : "RDC"}</span>
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <MessageCircle size={16} className="text-[#C5A059]" />
                <a href="https://wa.me/243981962762" data-testid="footer-whatsapp" className="link-underline">+243 981 962 762</a>
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <Mail size={16} className="text-[#C5A059]" />
                <a href="mailto:contact@suzelholding.com" data-testid="footer-email" className="link-underline">contact@suzelholding.com</a>
              </li>
              <li className="flex items-center gap-3 text-white/80 pt-2">
                <Instagram size={16} className="text-[#C5A059]" />
                <a href="#" data-testid="footer-instagram" className="link-underline">@suzelholding</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-line opacity-30 mb-8" />
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-white/40 font-grotesk uppercase tracking-[0.2em]">
          <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
          <div className="flex items-center gap-6">
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-white/30 hover:text-[#C5A059] transition-colors">Admin</Link>
            <span>www.suzelholding.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
